import { Injectable, Pipe, PipeTransform } from "@angular/core";

@Injectable({
    "providedIn": "root"
})
@Pipe({ 
    "name": "constructionstatus",
    standalone: true })
export class ConstructionStatusPipe implements PipeTransform {
    transform (value: number): string {
        switch (value) {
            case 0:
                return "";
            case 1:
                return "Configured";
            case 2:
                return "RTC";
            case 3:
                return "Start";
            case 4:
                return "Frame";
            case 5:
                return "Second";
            case 6:
                return "Final";
            default:
                return "";
        }
    }
}
